import { environment } from './../environments/environment';
const ɵ0 = environment.BACKEND_SERVER_URL;
export class AppModule {
}
export { ɵ0 };
